export const attachment = [
  {
    id: 1,
    name: "None",
    title: "None",
  },
  {
    id: 2,
    name: "Video",
    title: "Video",
  },
  {
    id: 3,
    name: "Audio",
    title: "Audio",
  },
];

export const option = [
  {
    id: 1,
    title: "I",
    value: "first",
  },
  {
    id: 2,
    title: "II",
    value: "second"
  },
  {
    id: 3,
    title: "III",
    value: "third"
  },
  {
    id: 4,
    title: "IV",
    value: "fourth"
  },
];
